// extracted by mini-css-extract-plugin
export var gridItem = "Grid-module--grid-item--2mN_O";